/**
 * Customer-facing name for GEP (Groundlight Edge Platform) devices.
 *
 * GEP stays the internal/technical name, used in code and comments only.
 */
export const VISION_CORE_NAMING = {
  uiName: "Vision Core",
  uiNamePlural: "Vision Cores",
};
